import { render, staticRenderFns } from "./customerQuotationDetail.vue?vue&type=template&id=9fd9e6d2&scoped=true"
import script from "./customerQuotationDetail.vue?vue&type=script&lang=js"
export * from "./customerQuotationDetail.vue?vue&type=script&lang=js"
import style0 from "./customerQuotationDetail.vue?vue&type=style&index=0&id=9fd9e6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd9e6d2",
  null
  
)

export default component.exports